import { fetchJson } from '~/utils/fetch-json-v2';
import { buildQueryString } from '~/utils/query-string';
import type {
  CreateInvitationPayload,
  Member,
  MembersApiResponse,
  MembersQueryParams,
  SentInvitation,
  SentInvitationsApiResponse,
  SentInvitationsQueryParams,
} from './types';

export async function getMembersApi(
  orgUrn: string,
  params: MembersQueryParams = {},
) {
  const queryString = buildQueryString(params);
  const url = `/orgs/${orgUrn}/members${queryString ? `?${queryString}` : ''}`;

  return fetchJson<MembersApiResponse>(url, {
    method: 'GET',
  });
}

export async function getMemberByIdApi(orgUrn: string, id: string) {
  return fetchJson<Member>(`/orgs/${orgUrn}/members/${id}`, {
    method: 'GET',
  });
}

export async function createMemberApi(
  orgUrn: string,
  member: Omit<Member, 'urn' | 'created_at' | 'updated_at'>,
) {
  return fetchJson<Member>(`/orgs/${orgUrn}/members`, {
    method: 'POST',
    body: member,
  });
}

export async function updateMemberApi(
  orgUrn: string,
  id: string,
  member: Partial<Omit<Member, 'urn' | 'created_at' | 'updated_at'>>,
) {
  return fetchJson<Member>(`/orgs/${orgUrn}/members/${id}`, {
    method: 'PUT',
    body: member,
  });
}

export async function deleteMemberApi(orgUrn: string, id: string) {
  return fetchJson<void>(`/orgs/${orgUrn}/members/${id}`, {
    method: 'DELETE',
  });
}

export async function getSentInvitationsApi(
  params: SentInvitationsQueryParams = {},
) {
  const queryString = buildQueryString({
    limit: 20,
    offset: 0,
    order: 'desc',
    ...params,
  });

  return fetchJson<SentInvitationsApiResponse>(
    `/invites${queryString ? `?${queryString}` : ''}`,
    {
      method: 'GET',
    },
  );
}

export async function createInvitationApi(
  orgUrn: string,
  payload: CreateInvitationPayload,
) {
  return fetchJson<SentInvitation>(`/orgs/${orgUrn}/invite`, {
    method: 'POST',
    body: payload,
  });
}

export async function resendInvitationApi(code: string) {
  return fetchJson<SentInvitation>(`/invite/${code}/resend`, {
    method: 'POST',
  });
}
